//sl.js
// 斯洛文尼亚语
const sl = {
  //公共
  common: {
    notSupport: 'Tvoj brskalnik ne podpira celozaslonskega načina',
    loadFail: 'Nalaganje teme ni uspelo',
    noPermission: 'Žal nimate dovoljenja za dostop do te strani',
    backHome: 'Vrnitev na domačo stran',
    noExit: 'Stran, do katere želite dostopati, ne obstaja',
    serverError: 'Na strežniku je prišlo do napake',
    slide: 'Povlecite desno',
    veryHigh: 'Zelo visoka',
    high: 'Visoka',
    target: 'Ciljna',
    urgentLow: 'Zelo nizka',
    agpNoData: 'Poročilo AGP zahteva vsaj 5 dni podatkov',
    noDataStr: 'Ni podatkov',
    setting: 'Nastavitve',
    personInfo: 'Osnovni podatki',
    updatePwd: 'Spremeni geslo',
    upHead: 'Naloži slike',
    inRange: 'V razponu',
    normal: 'Normalno',
    low: 'Nizko',
    previous: 'Prejšnje',
    next: 'Naslednje',
    search: 'Iskanje',
    reset: 'Ponastavi',
    cancel: 'Prekliči',
    ok: 'V redu',
    confirm: 'Potrdi',
    save: 'Shrani',
    submit: 'Pošlji',
    successful: 'Uspešno',
    pleaseEnter: 'Prosimo, vnesite',
    pleaseSelect: 'Prosimo, izberite',
    success: 'Uspeh',
    confirmLogout: 'Ali ste prepričani, da se želite odjaviti?',
    updateSuccessed: 'Posodobitev uspešna',
    warning: 'Opozorilo',
    date: 'Datum',
    start: 'Začetek',
    end: 'Konec',
    sevenDays: '7 dni',
    fourteenDays: '14 dni',
    thirtyDays: '30 dni',
    signOut: 'Odjava',
    personalInformation: 'Osebni podatki',
    email: 'E-pošta',
    name: 'Ime',
    mobile: 'Telefon',
    dateOfBirth: 'Datum rojstva',
    gender: 'Spol',
    diabeteType: 'Tip diabetesa',
    dateOfDignose: 'Leto diagnoze',
    remarks: 'Opombe',
    optionMale: 'Moški',
    optionFemale: 'Ženska',
    optionUnknow: 'Raje ne povem',
    noDiabetes: 'Brez diabetesa',
    diabeteTypeI: 'Tip I',
    diabeteTypeII: 'Tip II',
    diabeteSpecial: 'Posebno',
    diabeteGestational: 'Gestacijski diabetes',
    diabeteOthers: 'Drugo',
    ruleMsgEmail: 'Vnesite e-pošto',
    ruleMsgName: 'Vnesite ime',
    ruleMsgMobile: 'Vnesite telefonsko številko',
    ruleMsgBirthday: 'Izberite datum rojstva',
    ruleMsgSex: 'Izberite spol',
    ruleMsgDiabeteType: 'Izberite tip diabetesa',
    ruleMsgDateOfDignose: 'Izberite leto diagnoze',
    ruleMsgRemarks: 'Vnesite opombo',
    ruleMsgCorrectMobile: 'Vnesite pravilno telefonsko številko',
    oldPassword: 'Staro geslo',
    newPassword: 'Novo geslo',
    confirmPassword: 'Potrdite geslo',
    ruleMsgOldPassword: 'Vnesite staro geslo',
    ruleMsgNewPassword: 'Vnesite novo geslo',
    ruleMsgConfirmPassword: 'Potrdite geslo',
    passwordInconsistent: 'Vneseni gesli se ne ujemata',
    passwordModifySuccessed:
      'Vaše geslo je bilo ponastavljeno, prosimo prijavite se ponovno!',
    monday: 'Pon',
    tuesday: 'Tor',
    wednesday: 'Sre',
    thursday: 'Čet',
    friday: 'Pet',
    saturday: 'Sob',
    sunday: 'Ned',
    sn: 'SN',
    startDate: 'Datum začetka',
    days: 'dni',
    pdfDate: 'Cilj',
    close: 'zapri',
    // inputTip: 'Vnesite ključne besede za iskanje',
    inputTip: 'Vnesite ključne besed...',
    polarization: 'Naprava se inicializira',
    hour: 'h',
    minutes: 'min',
    seconds: 's',
    reportDownLoadTip: 'Vaše poročilo ni bilo ustvarjeno 5 dni',
    age: 'starost',
    goal: 'Cilj',
    expired: 'Senzor je potekel',
    lastTime: 'Zadnji osveženi čas',
    timeZone: 'Časovni pas'
  },
  //路由
  route: {
    login: 'Prijava',
    forget: 'Pozabljeno geslo',
    home: 'Domov',
    glucoseReport: 'Poročilo o glukozi',
    sessionReport: 'Poročilo seje',
    eventList: 'Seznam dogodkov',
    followerList: 'Seznam sledilcev',
    followerListQ: 'Zahteva opazovalca',
    settings: 'Nastavitve',
    profile: 'Profil'
  },
  //登录
  login: {
    rememberMe: 'Zapomni si me',
    forgetPassword: 'Pozabljeno geslo',
    agree: 'Prijava pomeni soglasje s FurCarer',
    privacyPolicy: 'Politika zasebnosti',
    CGMUser: 'Uporabnik CGM',
    follower: 'Sledilec',
    ruleMsgPassword: 'Vnesite geslo',
    login: 'Prijava',
    phonePlacehold: 'Vnesite telefonsko številko',
    codePlacehold: 'Vnesite potrditveno kodo',
    codePlaceholdInput: 'Please enter t...',
    phoneTip: 'Po telefonu',
    emialTip: 'Po e-pošti',
    codeTip: 'Pridobi potrditveno kodo',
    reGetTip: 'Ponovni prevzem'
  },
  layout: {
    collapseUp: 'Skrij meni',
    collapseDown: 'Razširi meni',
    refresh: 'Osveži',
    backHome: 'Domov',
    helpCenter: 'Center za pomoč',
    fullScreen: 'Celozaslonski način'
  },
  //忘记密码
  forget: {
    ruleMsgCode: 'Vnesite kodo',
    sendCode: 'Pošlji kodo',
    tipsMsgSendSuccess: 'Potrditvena koda je bila uspešno poslana!',
    tipsMsgModifySuccess: 'Sprememba gesla uspešna'
  },
  //首页
  home: {
    title: 'FurCarer Portal',
    todaysGlucose: 'Glukoza danes',
    todaysOverview: 'Pregled danes',
    maxGlucose: 'Maks. glukoza',
    minGlucose: 'Min. glukoza',
    avgGlucose: 'Povprečna glukoza',
    maxmumVariation: 'Maks. odstopanje',
    glucose: 'Glukoza',
    tir: 'TIR',
    latestGlucose: 'Zadnja glukoza',
    todayPercentage: '% danes v različnih razponih',
    fourHour: '4 ure',
    eightHour: '8 ur',
    twelveHour: '12 ur',
    twentyFourHour: '24 ur',
    glucoseOnly: 'Samo glukoza',
    sessionOverview: 'Pregled seje',
    glocuseMetrics: 'Metrični podatki o glukozi',
    agp: 'AGP',
    dailyGlucose: 'Dnevna glukoza',
    sessionGlucose: 'Glukoza seje',
    standTir: 'Standardni TIR',
    customTir: 'Prilagojen TIR',
    cancleGz: 'Prenehaj slediti',
    cancleText: 'Ali želite prenehati slediti trenutnemu uporabniku?',
    helpCenterTip: 'Funkcija še ni na voljo'
  },
  //血糖报告
  glucoseReport: {
    statics: 'Statistika',
    sixHour: '6-urni TIR',
    avgGlucose: 'Povprečna glukoza',
    maxGlucose: 'Maksimalna glukoza',
    minGlucose: 'Minimalna glukoza',
    cv: 'CV',
    high: 'Število visokih vrednosti',
    low: 'Število nizkih vrednosti',
    normal: 'Število normalnih vrednosti',
    tir: 'TIR',
    estimatedA1c: 'Ocenjeni A1c',
    min: 'Min',
    avg: 'Povprečje',
    max: 'Maks',
    maxVariation: 'Maks. odstopanje'
  },
  //血糖档案
  glucoseProfile: {
    avg: 'Povprečje',
    sd: 'SD',
    cv: 'CV'
  },
  //事件列表
  eventList: {
    all: 'Vse',
    bg: 'BG',
    meal: 'Obrok',
    sport: 'Šport',
    insulin: 'Inzulin',
    alert: 'Opozorilo',
    eventType: 'Vrsta dogodka',
    description: 'Opis',
    note: 'Opomba',
    highAlert: 'opozorilo o alarmu',
    calibration: 'Kalibracija',
    meds: 'Zdravila',
    time: 'Čas',
    detail: 'Podrobnosti',
    weigt: 'Teža'
  },
  // 关注列表
  followerList: {
    title: 'Uporabniki spremljanja',
    tabTitle: 'Upravljanje sledilcev',
    refreshText:
      'Avtomatska osvežitev (seznam uporabnikov se osvežuje vsakih 30 sekund)',
    addText: 'Dodaj',
    dataText: 'Podatki pridobljeni',
    timeText: 'minute',
    hourText: 'ure',
    agoText: ' pred',
    tableEmail: 'Vnesite številko računa',
    searchPlacehold: 'Vnesite številko računa za iskanje',
    pending: 'V čakanju',
    approved: 'Odobreno',
    rejected: 'Zavrnjeno',
    addFollower: 'Dodaj sledilca',
    editFollower: 'Uredi sledilca',
    tableName: 'Ime',
    tableAddTime: 'Čas dodajanja',
    tableStatus: 'Status',
    tableApproved: 'Odobreno',
    tableReject: 'Zavrni',
    tableStartSharing: 'Začni deliti',
    tableStopSharing: 'Prekini deljenje',
    op: 'Izvedi',
    sharing: 'Deljenje',
    notSharing: 'Ni deljeno',
    tableRemove: 'odstrani',
    note: 'Opomba',
    message: 'Sporočilo',
    ruleMsgEmailEmpty: 'Vnesite e-pošto za iskanje',
    ruleMsgNote: 'Vnesite opombo',
    ruleMsgMessage: 'Pustite sporočilo',
    ruleMsgEmailCorrect: 'Vnesite pravilno e-pošto',
    formAcknowledge:
      'Potrjujem, da dodajanje sledilca temu uporabniku omogoča ogled mojih podatkov',
    sendFollowRequest: 'Pošlji zahtevo za sledenje',
    setNote: 'Nastavi opombo',
    tipsAcknowledge:
      'Prosimo, označite polje in potrdite, da bo ta uporabnik lahko videl vaše podatke.',
    stopSharing: 'Prekini deljenje',
    startSharing: 'Začni deliti',
    removeUser: 'Odstrani uporabnika',
    confirmStopSharing:
      'Ali ste prepričani, da želite prekiniti deljenje podatkov o glukozi s tem uporabnikom?',
    confirmStartSharing:
      'Ali ste prepričani, da želite začeti deliti podatke o glukozi s tem uporabnikom?',
    confirmRemove:
      'Ali ste prepričani, da želite odstraniti tega uporabnika s seznama?',
    approvedFollower: 'Odobreni sledilec',
    rejectFollower: 'Zavrni sledilca',
    confirmApproved:
      'Ali ste prepričani, da želite odobriti to zahtevo za sledenje?',
    confirmReject:
      'Ali ste prepričani, da želite zavrniti to zahtevo za sledenje?',
    addTime: 'Čas dodajanja',
    check: 'Preveri',
    remove: 'Odstrani',
    removeUserTitle:
      'Ali ste prepričani, da želite odstraniti tega uporabnika s seznama?'
  },
  //设置
  settings: {
    title: 'Nastavitve ravni glukoze',
    unitSet: 'Nastavitev enot',
    targetSet: 'Prilagojena nastavitev TIR',
    alertSet: 'Nastavitev opozoril',
    highAlert: 'Visoko opozorilo',
    lowAlert: 'Nizko opozorilo',
    urgentLow: 'Nujno nizko',
    urgentHigh: 'Nujno visoko',
    target: 'Ciljna vrednost'
  },
  // pdf
  pdf: {
    dailyStatistics: 'Dnevna statistika',
    title: 'AGP poročilo',
    page: 'Stran',
    generated: 'Generirano',
    lage: 'LAGE',
    mage: 'MAGE',
    modd: 'MODD',
    range: 'Čas v ciljnem območju',
    timeInRange: 'Čas v ciljnem območju (TIR)',
    agpTitle: 'Ambulantni profil glukoze (AGP)',
    agpSubTitle:
      'AGP je povzetek vrednosti glukoze iz obdobja poročila, prikazanih kot da so se zgodile v enem dnevu z medianami (50 %) in drugimi percentili',
    dailyTitle: 'Dnevni profil glukoze',
    dailySubTitle:
      'Vsak dnevni profil predstavlja obdobje od polnoči do polnoči',
    device: 'Naprava',
    tDevice: 'Terminalska naprava',
    print: 'Natisni',
    model: 'Model',
    deviceSn: 'Serijska številka naprave',
    effectiveData: 'Učinkoviti podatki',
    days: 'Dnevi',
    appVer: 'Različica aplikacije',
    smartPhoneModel: 'Model pametnega telefona',
    osVersion: 'Različica operacijskega sistema',
    appSetting: 'Nastavitve aplikacije',
    GoalsforType1andType2Diabetes:
      'Cilji za sladkorno bolezen tipa 1 in tipa 2',
    Each1timeinrange15minutes: 'Vsakih 1 % časa v območju ~= 15 minut',
    note: 'Opomba: Enota % velja za standard DCCT, enota mmol/mol pa velja za standard IFCC.',
    DOB: 'Datum rojstva',
    SN: 'SN'
  },
  // 字段
  field: {
    timeCgmActive: 'Čas aktivnega CGM',
    gmi: 'GMI',
    gri: 'GRI',
    eHbA1c: 'eHbA1c',
    avgPerDay: 'Povprečno število kalibracij na dan',
    glucoseAbility: 'Spremenljivost glukoze',
    lage: 'LAGE',
    mage: 'MAGE',
    tar: 'TAR',
    tbr: 'TBR',
    calibrations: 'Število kalibracij'
  },
  agp: {
    agpTitle: 'Ambulantni profil glukoze（AGP）',
    centerLine: 'Mediana',
    areaLine: 'Interval',
    target: 'Ciljno območje'
  },
  basic: {
    customTir: 'Prilagojeni TIR',
    bloodTip: 'Nastavitve opomnikov za glukozo',
    bloodUnit: 'Enota glukoze',
    highTip: 'Opozorilo za visoko glukozo',
    lowTip: 'Opozorilo za nizko glukozo',
    unitText: 'Samodejna nastavitev glede na regijo države',
    selectTip: 'Kliknite ikono za izbiro ali preklic ustreznega datuma',
    selectAll: 'Izberi vse'
  },
  report: {
    threeMonth: 'Zadnje 3 mesece',
    sixMonth: 'Skoraj 6 mesecev',
    yearText: 'Zadnje leto',
    showAll: 'Pokaži vse',
    all: 'Vse',
    selectDate: 'Izberi časovno obdobje',
    to: 'do',
    startDt: 'Začetni datum',
    endDt: 'Končni datum',
    betaTest: 'Beta testiranje',
    bloodData: 'Podatki o glukozi',
    userCount: 'Uporabniški račun'
  },
  petDetail: {
    variety: 'Pasma',
    type: 'Vrsta inzulina',
    freq: 'Pogostost inzulina',
    lente: 'Lente',
    insulin: 'Inzulin glargin',
    pzi: 'PZI',
    nph: 'NPH',
    detemir: 'Detemir'
  },
  pdfReport: {
    title: 'Poročilo AGP',
    snNumber: 'Serijska številka',
    page: 'Stran',
    createTime: 'Generirano',
    petInfo: 'Informacije o hišnem ljubljenčku',
    petName: 'Ime hišnega ljubljenčka',
    birthday: 'Datum rojstva',
    freq: 'Pogostost inzulina.',
    petType: 'Vrsta hišnega ljubljenčka',
    age: 'Starost',
    registerType: 'Vrsta injekcijske brizge',
    basicBloodData: 'Metrični podatki o glukozi',
    dbText: 'Čas v območju（TIR）',
    target: 'Cilji za sladkorno bolezen tipa 1 in 2',
    recordTime: 'Čas snemanja',
    tag: 'Oznaka',
    event: 'Dogodek',
    eventDetail: 'Podrobnosti dogodka',
    mulityText: 'Večdnevni graf trenda glukoze',
    mulitySubText:
      'Večdnevni profili glukoze predstavljajo časovno obdobje enega cikla naprave',
    avageBlood: 'Povprečna glukoza',
    bloodText: 'MODD',
    highTip: 'Opozorilo za visoko glukozo',
    lowTip: 'Opozorilo za nizko glukozo',
    cat: 'Mačka',
    dog: 'Pes',
    country: 'Država',
    insulinDose: 'Odmerek inzulina',
    weightUnit: 'kg'
  },
  eventDetail: {
    Empty: 'Zajtrk',
    After_Breakfast: 'Po zajtrku',
    Before_Lunch: 'Pred kosilom',
    Breakfast: 'Zajtrk',
    Lunch: 'Kosilo',
    Dinner: 'Večerja',
    Before_Sleep: 'Pred spanjem',
    Extra: 'Dodatno',
    Short_acting: 'Kratkodelujoč',
    Pre_mixed: 'Predmešan',
    Long_acting: 'Dolgodelujoč',
    Middle_acting: 'Srednjedelujoč',
    hour: 'h',
    minutes: 'min'
  }
};
export default sl;
